import { Action } from '@ngrx/store';
import * as models from '../../../../shared/model/api/models';

export const SELECT_ORDER_ACTION = {
   SELECT_PROTECTION_PRODUCT: '[PROTECTION_PRODUCT] SELECT PROTECTION PRODUCT',
   SELECT_LEFT_PANEL:'[PROTECTION_PRODUCT] SELECT_PANEL',
   CUSTOMER_MENU:'[NAVIGATETAB] EDIT_CLICKED',
   LOAD_PP_LIST_WRITEUP_DETAILS: '[PP_LIST_WRITEUP_DETAILS] Initate load for pp list and writeup details',
   LOAD_PP_LIST_WRITEUP_DETAILS_SUCCESS: '[PP_LIST_WRITEUP_DETAILS] protection prodcuts and writeup details loaded success',
   LOAD_PP_LIST_WRITEUP_DETAILS_FAIL: '[PP_LIST_WRITEUP_DETAILS] protection porducts or wirteup details service fail',
   UPDATE_WORKSHEET:'[UPDATED_PP_LIST] protection product list update',
   UPDATE_WORKSHEET_SUCCESS:'[UPDATED_PP_LIST_SUCCESS] protection product list updated',
   UPDATE_WORKSHEET_FAIL:'[UPDATED_PP_LIST_SUCCESS] protection product list update failed',
   RATE_TERM_DETAILS: '[RATE_TERM] get rate term details for updated protection products',
   RATE_TERM_DETAILS_SUCCESS: '[RATE_TERM] get rate term details for updated protection products success',
   RATE_TERM_DETAILS_FAIL: '[RATE_TERM] get rate term details for updated protection products failed',
   UPDATE_WEBSOCKET_DATA: '[WEBSOCKET_DATA] update data from websocket message',
   PROTECTION_SEND_NEW_OFFER: '[DealDetails] Protection Send new offer for deal',
   PROTECTION_SEND_NEW_OFFER_SUCCESS: '[DealDetails] Protection Send new offer for deal Success',
   PROTECTION_SEND_NEW_OFFER_FAIL: '[DealDetails] Protection Send new offer for deal Fail',
   PROTECTION_RESET_ACTION: '[DealDetails] Protection products reset action',
   DEAL_UPDATED : '[DealDetails] Deal updated',
   CHECK_OCA_STATUS : '[PROTECTION_PRODUCT] Check OCA Status',
   CHECK_OCA_STATUS_SUCCESS : '[PROTECTION_PRODUCT] Check OCA Status on success',
   CHECK_OCA_STATUS_FAIL : '[PROTECTION_PRODUCT] Check OCA Status on fail',
   RESET_OCA_STATUS : '[PROTECTION_PRODUCT] Reset OCA status',
   OCA_STATUS_TRUE : '[PROTECTION_PRODUCT] Reset OCA status to True',
   GET_INCENTIVE_ARRAY: '[PROTECTION_PRODUCT] Initiate Incentive array service',
   GET_INCENTIVE_ARRAY_SUCCESS: '[PROTECTION_PRODUCT] Incentive array service pass',
   GET_INCENTIVE_ARRAY_FAIL: '[PROTECTION_PRODUCT] Incentive array service fail',
   MONTHLY_PRICES_CUSTOMER_VIEW: '[PP_LIST_WRITEUP_DETAILS] MONTHLY_PRICES_CUSTOMER_VIEW',
   MONTHLY_PRICES_CUSTOMER_VIEW_SUCCESS: '[PP_LIST_WRITEUP_DETAILS] MONTHLY_PRICES_CUSTOMER_VIEW_SUCCESS',
   MONTHLY_PRICES_CUSTOMER_VIEW_FAIL: '[PP_LIST_WRITEUP_DETAILS] MONTHLY_PRICES_CUSTOMER_VIEW_FAIL',
   ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW: '[PP_LIST_WRITEUP_DETAILS] ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW',
   ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW_SUCCESS: '[PP_LIST_WRITEUP_DETAILS] ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW_SUCCESS',
   ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW_FAIL: '[PP_LIST_WRITEUP_DETAILS] ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW_FAIL',
   PROTECTION_DEAL_UPDATE: '[PROTECTION_PRODUCT] Deal Update',
   PROTECTION_DEAL_UPDATE_SUCCESS: '[PROTECTION_PRODUCT] Deal Update on success',
   PROTECTION_DEAL_UPDATE_FAIL: '[PROTECTION_PRODUCT] Deal Update on fail',
   WEB_SOCKET_DEAL_UPDATE: '[PROTECTION_PRODUCT] WEB_SOCKET_DEAL_UPDATE',
   WEB_SOCKET_DEAL_UPDATE_DEAL_DATE: '[PROTECTION_PRODUCT] WEB_SOCKET_DEAL_UPDATE_DEAL_DATE',
   WEB_SOCKET_DEAL_UPDATE_RATE_TERM: '[PROTECTION_PRODUCT] WEB_SOCKET_DEAL_UPDATE_RATE_TERM',
   WEB_SOCKET_DEAL_UPDATE_RATE_TERM_SUCCESS: '[PROTECTION_PRODUCT] WEB_SOCKET_DEAL_UPDATE_RATE_TERM_SUCCESS',
   CUSTOMER_VIEW_DEAL_FINALIZE: '[CUSTOMER VIEW] Deal Finalize',
   CUSTOMER_VIEW_DEAL_FINALIZE_SUCCESS: '[CUSTOMER VIEW] Deal Finalize on success',
   CUSTOMER_VIEW_DEAL_FINALIZE_FAIL: '[CUSTOMER VIEW] Deal Finalize on fail',
   DOFU_UPDATED: '[CUSTOMER VIEW] Dofu Update',
   LOAD_DOFU_UPDATED_PP_LIST: '[CUSTOMER VIEW] Dofu Updated Product List',
   LOAD_DOFU_UPDATED_PP_LIST_SUCCESS: '[CUSTOMER VIEW] Dofu Updated Product List on success',
   LOAD_DOFU_UPDATED_PP_LIST_FAIL: '[CUSTOMER VIEW] Dofu Updated Product List on fail'
}
export enum SwitchLeftPanel{
ProductList=0,
ProductEdit=1
}

export class CustomerViewSelectLeftPanel implements Action{
    public readonly type: string = SELECT_ORDER_ACTION.SELECT_LEFT_PANEL;
    constructor(public payload?: any) {}
}

export class CustomerViewSelectProtectionProduct implements Action{
    public readonly type: string = SELECT_ORDER_ACTION.SELECT_PROTECTION_PRODUCT;
    constructor(public payload?: any) {}
}


export class CustomerViewProtectionProductsList implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.LOAD_PP_LIST_WRITEUP_DETAILS;
    constructor(public payload?: any) { }
}

export class CustomerViewProtectionProductsListSuccess implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.LOAD_PP_LIST_WRITEUP_DETAILS_SUCCESS;
    constructor(public payload?: any) { }
}

export class CustomerViewProtectionProductsListFail implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.LOAD_PP_LIST_WRITEUP_DETAILS_FAIL;
    constructor(public payload?: any) { }
}
export class CustomerViewUpdateWorksheet implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.UPDATE_WORKSHEET;
    constructor(public payload?: any) { }
}
export class CustomerViewPUpdateWorksheetSuccess implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.UPDATE_WORKSHEET_SUCCESS;
    constructor(public payload?: any) { }
}
export class CustomerViewUpdateWorksheetFail implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.UPDATE_WORKSHEET_FAIL;
    constructor(public payload?: any) { }
}

export class CustomerViewMenu implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.CUSTOMER_MENU;
    constructor(public payload?: any) { }
}

export class CustomerViewRateTermDetails implements Action{
    public readonly type: string = SELECT_ORDER_ACTION.RATE_TERM_DETAILS;
    constructor(public payload?: any) { }
}

export class CustomerViewRateTermDetailsSuccess implements Action{
    public readonly type: string = SELECT_ORDER_ACTION.RATE_TERM_DETAILS_SUCCESS;
    constructor(public payload?: any) { }
}

export class CustomerViewRateTermDetailsFail implements Action{
    public readonly type: string = SELECT_ORDER_ACTION.RATE_TERM_DETAILS_FAIL;
    constructor(public payload?: any) { }
}
export class GetMonthlyPricesCustomerView implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.MONTHLY_PRICES_CUSTOMER_VIEW;
    constructor(public payload?: any) { }
}
export class GetMonthlyPricesCustomerViewSuccess implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.MONTHLY_PRICES_CUSTOMER_VIEW_SUCCESS;
    constructor(public payload?: any) { }
}
export class GetMonthlyPricesCustomerViewFail implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.MONTHLY_PRICES_CUSTOMER_VIEW_FAIL;
    constructor(public payload?: any) { }
}

export class AddOrRemoveCoverageCustomerView implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW;
    constructor(public payload?: any) { }
}

export class AddOrRemoveCoverageCustomerViewSuccess implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW_SUCCESS;
    constructor(public payload?: any) { }
}

export class AddOrRemoveCoverageCustomerViewFail implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.ADD_OR_REMOVE_COVERAGE_CUSTOMER_VIEW_FAIL;
    constructor(public payload?: any) { }
}
export class CustomerViewWebsocketDealUpdate implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.WEB_SOCKET_DEAL_UPDATE;
    constructor(public payload?: any) { }
}

export class CustomerViewWebsocketUpdateDealDate implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.WEB_SOCKET_DEAL_UPDATE_DEAL_DATE;
    constructor(public payload?: any) { }
}

export class CustomerViewWebsocketDealUpdateRateTerm implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.WEB_SOCKET_DEAL_UPDATE_RATE_TERM;
    constructor(public payload?: any) { }
}

export class CustomerViewWebsocketRateTermDetailsSuccess implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.WEB_SOCKET_DEAL_UPDATE_RATE_TERM_SUCCESS;
    constructor(public payload?: any) { }
}

// export class MonthlyPricesCustomerViewSuccess implements Action{
//     public readonly type: string = SELECT_ORDER_ACTION.MONTHLY_PRICES_CUSTOMER_VIEW_SUCCESS;
//     constructor(public payload?: any) { }
// }

export class CustomerViewWebsocketDataUpdate implements Action{
    public readonly type: string = SELECT_ORDER_ACTION.UPDATE_WEBSOCKET_DATA;
    constructor(public payload?: any) { }
}

/**
* Method used to Send New Offer
*/
export class ProtectionSendNewOfferAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.PROTECTION_SEND_NEW_OFFER;
  
    constructor(public payload: any) { }
  }
  
  /**
   * Method used to handle the Success action for Send New Offer Success method
   */
  export class ProtectionSendNewOfferSuccessAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.PROTECTION_SEND_NEW_OFFER_SUCCESS;
  
    constructor(public payload: models.DealDetails) { }
  }
  /**
   * Method used to handle the Fail action for Send New Offer fail method
   */
  export class ProtectionSendNewOfferFailAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.PROTECTION_SEND_NEW_OFFER_FAIL;
  
    constructor(public payload: any) { }
  }

  /**
   * Method used to handle the reset action for Send New Offer fail method
   */
  export class ProtectionResetAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.PROTECTION_RESET_ACTION;
      
  }
 /**
   * Method used to handle the deal update action
   */
  export class DealUpdateAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.DEAL_UPDATED;
      
  }

/**
* Method used to Check OCA Status
*/
export class CheckOCAStatusAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.CHECK_OCA_STATUS;

    constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Check OCA Status Success method
 */
export class CheckOCAStatusActionSuccessAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.CHECK_OCA_STATUS_SUCCESS;

    constructor(public payload: any) { }
}
/**
 * Method used to handle the Fail action for Check OCA Status fail method
 */
export class CheckOCAStatusActionFailAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.CHECK_OCA_STATUS_FAIL;

    constructor(public payload: any) { }
}

export class ResetOCAStatusAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.RESET_OCA_STATUS;
}

export class ResetOCAStatusTrueAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.OCA_STATUS_TRUE;
}

/**
 * Method used to Calculate Price Estimate Array
 */
export class GetIncentiveArrayAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.GET_INCENTIVE_ARRAY;
    constructor(public payload: any) { }
}

/**
 * Method used to handle the Success action for Calculate Price Estimate Array Success method
 */
export class GetIncentiveArraySuccessAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.GET_INCENTIVE_ARRAY_SUCCESS;
    constructor(public payload: {}) { }
}

/**
 * Method used to handle the Failure action for Calculate Price Estimate Array Fail method
 */
export class GetIncentiveArrayFailAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.GET_INCENTIVE_ARRAY_FAIL;
    constructor(public payload: string) { }
}

 /**
   * Method used to handle the deal update when protection products updated
   */
  export class DealUpdateWithPP implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.PROTECTION_DEAL_UPDATE;
    constructor(public payload: {}) { }
  }

/**
  * Method used to handle the Success action for Calculate Price Estimate Array Success method
  */
export class DealUpdateWithPPSucessAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.PROTECTION_DEAL_UPDATE_SUCCESS;
    constructor(public payload: {}) { }
}

/**
  * Method used to handle the Failure action for Calculate Price Estimate Array Success method
  */
 export class DealUpdateWithPPFailAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.PROTECTION_DEAL_UPDATE_FAIL;
    constructor(public payload?: any) { }
}

/**
   * Method used to update status when confirm on customer view
   */
  export class CustomerViewFinalize implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.CUSTOMER_VIEW_DEAL_FINALIZE;
    constructor(public payload: {}) { }
  }

/**
  * Method used to handle the Success action for finalizing the deal
  */
export class CustomerViewFinalizeSuccessAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.CUSTOMER_VIEW_DEAL_FINALIZE_SUCCESS;
    constructor(public payload: {}) { }
}

/**
  * Method used to handle the Failure action for finalizing the deal
  */
 export class CustomerViewFinalizeFailAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.CUSTOMER_VIEW_DEAL_FINALIZE_FAIL;
    constructor(public payload?: any) { }
}

/**
   * Method used to handle the dofu update action
   */
 export class DofuUpdateAction implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.DOFU_UPDATED;
      
}

export class CustomerViewDofuUpdatedProductsList implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.LOAD_DOFU_UPDATED_PP_LIST;
    constructor(public payload?: any) { }
}

export class CustomerViewDofuUpdatedProductsListSuccess implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.LOAD_DOFU_UPDATED_PP_LIST_SUCCESS;
    constructor(public payload?: any) { }
}

export class CustomerViewDofuUpdatedProductsListFail implements Action {
    public readonly type: string = SELECT_ORDER_ACTION.LOAD_DOFU_UPDATED_PP_LIST_FAIL;
    constructor(public payload?: any) { }
}

export type CustomerViewProtectionProductUIAction = CustomerViewSelectProtectionProduct | CustomerViewSelectLeftPanel | CustomerViewProtectionProductsList | 
    CustomerViewProtectionProductsListSuccess | CustomerViewProtectionProductsListFail | CustomerViewUpdateWorksheet | CustomerViewRateTermDetails | 
    CustomerViewRateTermDetailsSuccess | CustomerViewRateTermDetailsFail | CustomerViewPUpdateWorksheetSuccess | CustomerViewUpdateWorksheetFail | 
    CustomerViewMenu | CustomerViewWebsocketDataUpdate | ProtectionSendNewOfferAction | 
    ProtectionSendNewOfferSuccessAction | ProtectionSendNewOfferFailAction | ProtectionResetAction | DealUpdateAction | CheckOCAStatusAction | CheckOCAStatusActionSuccessAction | 
    CheckOCAStatusActionFailAction | ResetOCAStatusAction |ResetOCAStatusTrueAction | GetIncentiveArrayAction | GetIncentiveArraySuccessAction | GetIncentiveArrayFailAction | 
    AddOrRemoveCoverageCustomerViewSuccess | AddOrRemoveCoverageCustomerViewFail | DealUpdateWithPP | DealUpdateWithPPSucessAction | DealUpdateWithPPFailAction | 
    CustomerViewWebsocketDealUpdate | CustomerViewWebsocketUpdateDealDate | CustomerViewWebsocketDealUpdateRateTerm | CustomerViewWebsocketRateTermDetailsSuccess |
    CustomerViewFinalize | CustomerViewFinalizeSuccessAction | CustomerViewFinalizeFailAction | DofuUpdateAction  | 
    CustomerViewDofuUpdatedProductsList | CustomerViewDofuUpdatedProductsListSuccess | CustomerViewDofuUpdatedProductsListFail ;